import { cn } from "../../lib/utils";

export function Skeleton({ className, ...props }) {
    return (
        <div
            className={cn("skeleton", className)}
            aria-hidden="true"
            {...props}
        />
    );
}
